import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { emailValidator } from './email-validator';

/**
 * Helper function to validate individual email using existing emailValidator
 */
export function isValidEmail(email: string): boolean {
    return emailValidator({ value: email } as AbstractControl) === null;
}

/**
 * Validator that requires array to be non-empty
 */
export function arrayRequired(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        if (!value || !Array.isArray(value) || value.length === 0) {
            return { arrayRequired: true };
        }

        return null;
    };
}

/**
 * Validator that limits maximum number of elements in array
 */
export function arrayMaxLength(maxLength: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        if (!value || !Array.isArray(value)) {
            return null; // No validation for non-arrays
        }

        if (value.length > maxLength) {
            return {
                arrayMaxLength: {
                    actualLength: value.length,
                    maxLength,
                    message: `Maksymalna liczba elementów: ${maxLength}. Aktualnie: ${value.length}`
                }
            };
        }

        return null;
    };
}

/**
 * Validator that requires minimum number of elements in array
 */
export function arrayMinLength(minLength: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        if (!value || !Array.isArray(value)) {
            return { arrayMinLength: { actualLength: 0, minLength, message: `Minimalna liczba elementów: ${minLength}` } };
        }

        if (value.length < minLength) {
            return {
                arrayMinLength: {
                    actualLength: value.length,
                    minLength,
                    message: `Minimalna liczba elementów: ${minLength}. Aktualnie: ${value.length}`
                }
            };
        }

        return null;
    };
}

/**
 * Validator for arrays of emails
 */
export function emailArrayValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const emails = control.value as string[];

        if (!emails || emails.length === 0) {
            return null; // Empty array is valid for this validator
        }

        const invalidEmails = emails.filter(email => !isValidEmail(email));

        if (invalidEmails.length > 0) {
            return {
                invalidEmails: {
                    invalid: invalidEmails,
                    message: `Niepoprawne adresy email: ${invalidEmails.join(', ')}`
                }
            };
        }

        return null;
    };
}
